import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=2b47f8bc&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=ts"
export * from "./Switcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47f8bc",
  null
  
)

export default component.exports